import { render, staticRenderFns } from "./UpdateExpire.vue?vue&type=template&id=4b71a409&scoped=true"
import script from "./UpdateExpire.vue?vue&type=script&lang=js"
export * from "./UpdateExpire.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b71a409",
  null
  
)

export default component.exports